<div class="auth-form">
  <div class="mt-150">
    <span class="title title--big">Восстановление доступа</span>
  </div>
  <div class="mt-32">
    <div class="color-blue-dark">
      Если электронный адрес
      <span class="no-wrap">{{ email | async }}</span> зарегистрирован в системе, на него отправлено письмо с инструкцией по восстановлению пароля. Если письмо не пришло в течении
      10 минут, проверьте папку "Спам".
    </div>
    <div class="mt-32">
      <a routerLink="{{ '/' + AUTH_PATHS.login }}" class="link link--blue-dark" id="appReturnToAuth">Вернуться к авторизации</a>
    </div>
  </div>
</div>
